module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Chapter Two")]), _vm._v(" "), _c('h3', {
    staticClass: "ct"
  }, [_vm._v("The Somaliland Camel Corps")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("n January 1914 he received a letter from an adjutant called ‘Tommy’ which referred to Ismay’s acceptance for the post, and in July 1914 Pug set sail for Somaliland in North-Eastern Africa, sad at leaving his comrades, but happy to be heading towards action."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_1",
      "id": "B_p1c2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" However, on his arrival on 9 August he was dismayed to hear that a major war had broken out with Germany. He was not alone in feeling that he was missing a major opportunity as other officers applied to be returned to their regiments but were ordered otherwise. They were typically young men seeing war as a noble adventure, but although fighting tribesmen on the North-West Frontier or Dervishes in Somaliland was dangerous, they regarded this as a secondary role compared to the industrialised war and carnage developing in Flanders. In the same month he gathered from the regimental orders of the 21st Cavalry that he had been promoted to captain."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_2",
      "id": "B_p1c2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" While in his new post he had many letters from old friends outlining the war in Europe, one from an Eric Dobs explaining what life was like in the Western Front trenches, and another from a Cecil Allanson in the Gurkha Rifles with an account of fighting in the Dardanelles, later describing its failure and his being wounded."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_3",
      "id": "B_p1c2_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pug may have thought he was missing a great opportunity, which was hardly the case, but in his memoirs he tried to explain why the orders to fight in Somaliland were necessary, pointing out that the European powers enlarging their colonial assets had seized what was called British Somaliland following the Egyptian evacuation. Many men would die there upholding this assumed British territory, which ceased to exist in 1956, making it tempting to reflect on the loss of life in Afghanistan as the Western powers withdrew in 2021. Somaliland had not been a violent occupation and was peacefully managed by a British Vice-Consul from the coastal towns of Berbera and Bulhar, controlling a massive area of scrubland which was malaria ridden and largely unproductive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Nevertheless, the British occupancy was contested by Sayyid Mohammed Abdullah Hassan, known to the British as the Mad Mullah, supported by a Muslim poet known as Salihiyya Sufi. He led groups of determined Dervishes, following the same pattern as those who had wreaked havoc in Sudan in 1885 (fighting General Gordon) under the Mahdi. Many perceived in this Mohammed Abdullah Hassan, another Mad Mullah. The Dervishes may have been mere tribesmen in British eyes, but Pug admitted in his memoirs they were good soldiers, and while others denigrated them as fanatics, the fact remains they were a committed and determined body of fighters who had decided the British were the enemy by occupying their homeland. It will be long debated by historians as to whether the Dervishes were driven by religious or nationalistic motives, or even the economic crisis triggered by European occupation and the colonial ramifications for their nomadic lifestyle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The British decided to fight the Mad Mullah with a Camel Corps (and ponies) using a mixture of British and Indian officers and troops. Pug’s many papers contained his messages detailing his pursuit and keeping track of the Dervishes, one from a remote area called the Dudub Pass passing on information and his intended actions."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_4",
      "id": "B_p1c2_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" He was an acting intelligence officer, and reported on descriptions of forts, maps, Dervish organisation, tactics, the leading figures, and even a genealogical background of the Mullah; it was a considerable document over 100 pages long."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_5",
      "id": "B_p1c2_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The conditions were uncomfortable and dangerous, with long exhausting scrubland campaigns and food and water at a minimum, fighting against men who knew their land better than the occupiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pug’s immediate commander was Lieutenant Colonel Thomas Cubitt, and these years were marked by lengthy expeditions and patrols, trying to track down the various caves and fortresses where the Dervishes had made camp. Pug described an action in attempting to take a fortress at a place called Shimberberris in which he and fellow officers attacked the main gates under gunfire in which some of his colleagues lost their lives, with Pug noting that the Somalis were better soldiers than they had anticipated."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_6",
      "id": "B_p1c2_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" After this they were told by the government to put more offensive activities on hold because the war was going badly in France. Mullah’s forces were weakening so Pug and his colleagues simply went on patrols to keep an eye on their whereabouts and what was happening. Pug kept copies of his many orders and observations which are retained "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("in the archives, one from ‘Major H.L. Ismay, Commanding the Mounted Column, to The Officer Commanding Troops, Somaliland, Burao, 26 April 1919’, stating:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In view of the very distressed condition of the ponies, I decided to retain only one troop, and the Lewis Gun section of ‘C’ Company, and to send back the remainder to BURAO. I also sent back all camels which had shown signs of distress on the morning’s march."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_7",
      "id": "B_p1c2_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is an interesting report showing Pug’s sensitivity towards the animals in his care.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 1 April 1919 in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("London Gazette")]), _vm._v(" Pug was appointed as Lieutenant Colonel for his services with the Camel Corps."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_8",
      "id": "B_p1c2_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" After the Great War and with the armistice signed, it was decided to utilise the new RAF to finish the Mullah problem, who had already decided to move and in Pug’s opinion probably trying to hide in Italian Somaliland. The resistant but now fleeing Dervishes were concentrating around an area known as Tale from where various reconnaissance reports were studied, including information that it was believed the Mullah was heading in that direction."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_9",
      "id": "B_p1c2_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The RAF were all too happy to demonstrate the power that planes could play following their actions in the Great War. There is a sense of annoyance in Pug’s writing that the directions and orders came from the Air Ministry, which was an embryonic indicator of interservice tensions. Pug thought the plans were simple enough but not sensible as the Camel Corps had to wait until the planes had finished their task; he protested to no avail, and the Air Ministry remained adamant."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_10",
      "id": "B_p1c2_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" There were six aircraft, only one performed accurate bombing, one had a forced landing, and four failed to locate the target. The Dervishes took refuge in caves and the Camel Corps followed looking for information."), _c('a', {
    attrs: {
      "href": "#/xhtml/#A3",
      "id": "B3"
    }
  }, [_vm._v("*")]), _vm._v(" They chased some groups of Dervishes, but it was not easy and they suffered from lack of food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The RFC (Royal Flying Corps which had become the RAF on 1 April 1918) decided it was a success, and despite Pug’s reservations about using aircraft against tribesmen, it could be successful but brutal as Mussolini "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("was to prove when he took Ethiopia in 1936. The role of the RAF in Somaliland became in time something of a contentious issue, and the scrubland warfare was beginning to attract more public attention after the Great War. An article appeared in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackwood’s Magazine")]), _vm._v(" written by Sir Douglas Jardine, (Secretary Somaliland 1916–1923) drawing attention to this almost forgotten area."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_11",
      "id": "B_p1c2_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" This was followed by a book on the entire Somaliland war by the same author."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_12",
      "id": "B_p1c2_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" The debate over the role of the RAF became somewhat controversial in the early 1930s, often referring to the role of Hugh Trenchard, with disputes over the value of bombing compared to the more useful incursions by the Camel Corps."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_13",
      "id": "B_p1c2_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" As late as 1960 the debate raged on concerning the RAF contribution, in which Pug became involved with letters to the press."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_14",
      "id": "B_p1c2_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" He also wrote to the press with some criticism of the accuracy of a book written on the subject by Andrew Boyle."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_15",
      "id": "B_p1c2_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 29 November 1920 a report in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" mentioned promotions and rewards including a DSO for Pug which was further noted in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("London Gazette")]), _vm._v(" the same day."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_16",
      "id": "B_p1c2_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The Colonial Secretary Leo Amery also wrote a report commending the Camel Corps ‘led by Colonel Ismay’ and acknowledging the worthiness of the DSO."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_17",
      "id": "B_p1c2_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The Dervish rebellion eventually collapsed and according to a report the Mullah died from smallpox either on 23 November 1920 or 10 January 1921, no one could be certain."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_18",
      "id": "B_p1c2_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had not been a happy time for Pug who felt he had missed out on the Great War, which with the benefit of hindsight many modern readers may question. He may have felt cut off from major events while in the Camel Corps, and as early as April 1917 he expressed some unhappiness in which he described the feeling of no man’s land and the possibility he might leave the army."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_19",
      "id": "B_p1c2_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" He had times of leave from Somaliland and stayed in England, visited his mother in India (his father having died in 1914), and was in continual correspondence with her during her lifetime. He tended in these letters to address her as ‘My dearest little Mother’, and usually with homely information, writing on 18 March 1917 ‘the mail eventually rolled up last Wednesday and brought news telling me of your safe return to the old home. I’d give a great deal to have servants like yours out here.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_20",
      "id": "B_p1c2_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" He also wrote to her about the conditions in Somaliland with a frank honesty, referring to the Royal Flying Corps, the possibility of peace, the conditions for the soldiers, his eight-day trek, the problem "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("of deserters, and by 1917 was explaining that his work was dominated by politicians and was unsatisfactory."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_21",
      "id": "B_p1c2_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pug had also travelled to see Gallipoli to experience what he called ‘modern war’, but it was banned as a holiday venture as was France. He had attempted to join his old regiment fighting in Mesopotamia and they had tried to draw him back but to no avail. He had three leave periods, but he had no choice but to return to the Somaliland scrubland and deserts. It might be that Pug was disappointed in not being involved in the Great War, because he had become an expert on colonial tribal warfare but lacked experience in the new industrialised modern warfare of 1914–18, and he never held a command position under these conditions, and later would acknowledge that this was a serious disadvantage. As a typical young soldier he enjoyed excitement from the polo matches to the battlefield, but Somaliland had given him experience in organisation, administration, intelligence, planning and reporting, and although he probably did not realise it at the time this was to be part of his future. The experience of Somaliland never left him and years later in 1958 he gave a speech on the subject to the Royal Geographical Society."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#A_p1c2_22",
      "id": "B_p1c2_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He eventually set sail for England in April 1920 feeling unhappy and somewhat frustrated at the last few years, mainly because he felt he had missed out in the main action of the German war, which were the feelings of a typical young officer seeking action. Today he could have been considered lucky because although he had faced death in Somaliland, his chances of being killed or seriously wounded would have been more likely on the Western Front or Gallipoli. Reading between the lines it seems that he was on the verge of depression, which was later confirmed by the London Medical Board who diagnosed him as suffering from extreme war-weariness, and he was given leave for a year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While waiting at Aden he was offered a place at the Staff College at Quetta, and even considered resigning and responded with a polite refusal. Following a few months recuperating in the quietness of England he changed his mind about staff college and asked if he could be reconsidered; he had to wait but was given another nomination and permitted to sit the next examination in February 1922, and if successful he might be accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "ntline"
  }, [_vm._v("____________")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#B3",
      "id": "A3"
    }
  }, [_vm._v("*")]), _vm._v("  Hassan, the Mad Mullah, died on 21 December 1920 from smallpox aged 64; his grave is unknown but supposed to be near Imi in the Somali Region of Ethiopia.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76cdcdc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_P1Ch2.vue
// module id = 81
// module chunks = 0